import { queryParams } from './queryParams';
import {
  localizePublicSeoPath,
  PUBLIC_LOCALIZED_PAGE_PATHS,
} from '../config/publicSeoPages';
import { SECURITY_TRUST_PATH } from '../config/securityTrustSeo';
import { VIDEO_WATCH_PATHS } from '../config/videoWatchSeo';

function normalizePublicPathname(pathname: string): string {
  return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
}

const PRERENDERED_PUBLIC_PATHS = new Set([
  SECURITY_TRUST_PATH,
  ...VIDEO_WATCH_PATHS,
  ...PUBLIC_LOCALIZED_PAGE_PATHS.flatMap((path) => [
    path,
    normalizePublicPathname(localizePublicSeoPath(path, 'en')),
  ]),
]);

type QueryParamsReader = {
  get(key: string): string | null;
  has(key: string): boolean;
};

export function canHydratePublicLandingPrerender(
  pathname: string,
  rootHasPrerenderedContent: boolean,
  params: QueryParamsReader = queryParams,
  prerenderedPathname?: string,
): boolean {
  return (
    PRERENDERED_PUBLIC_PATHS.has(normalizePublicPathname(pathname)) &&
    rootHasPrerenderedContent &&
    matchesPrerenderedPath(pathname, prerenderedPathname) &&
    !hasAuthenticatedBootParams(params)
  );
}

function matchesPrerenderedPath(pathname: string, prerenderedPathname?: string): boolean {
  if (prerenderedPathname === undefined) {
    return pathname === '/';
  }

  return normalizePublicPathname(pathname) === normalizePublicPathname(prerenderedPathname);
}

function hasAuthenticatedBootParams(params: QueryParamsReader): boolean {
  return hasMagicLinkParams(params) || hasAdminBootParam(params);
}

function hasMagicLinkParams(params: QueryParamsReader): boolean {
  return params.has('sessionId') && params.has('token');
}

function hasAdminBootParam(params: QueryParamsReader): boolean {
  const admin = params.get('admin');

  return admin === '1';
}
